module.exports = __webpack_public_path__ + "img/ic-instagram.33dedd64.svg";